import {
  ApplicationConfig,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { inject } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from '@aurrica-web/shared-i18n';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@aurrica-web/auth';
import {
  provideAuthAppFlow,
  provideAuthSessionInitializer,
  provideDesktopUpdaterInitializer,
  providePushNotificationBootstrap,
} from '@aurrica-web/core-data';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faCircleInfo,
  faEye,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import { provideSignalFormsConfig } from '@angular/forms/signals';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideSignalFormsConfig({
      // We style fields with Tailwind utilities; disable automatic class toggling.
      classes: {},
    }),
    provideAppInitializer(() => {
      const library = inject(FaIconLibrary);
      library.addIcons(faCircleInfo, faEye, faEyeSlash);
    }),
    provideAuthAppFlow('admin'),
    provideAuthSessionInitializer(),
    provideDesktopUpdaterInitializer(),
    providePushNotificationBootstrap(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'fr'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
